import Aos from "aos";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import "./about.scss";

function Home(props) {
	Aos.init({
		delay: 500,
		once: true
	});
	return (
		<div className="sec4">
			<div className="container">
				<div className="sec4Head">
					<h1 className="title" data-aos="-up">
					GGI: A Pioneer in Gemological Excellence
					</h1>
				<h1 className="title" data-aos="-up">	Laboratory Services

					</h1>
					<p data-aos="-in-up">
					GGI is at the forefront of gemological innovation, offering a comprehensive range of laboratory services. As the first laboratory in Pakistan to provide online verification of gemstone certificates, GGI ensures transparency and trust in the gemstone market. Additionally, GGI is the pioneer in sealing diamonds and gemstones, further safeguarding their authenticity
					</p>
				</div>
				<div className="stepsReport col-sm-12">
					<div className="innerSteps">
					<div className="stepDiv col-lg-2 col-md-6 col-xs-12 mt-5">
							<div className="innerStepDiv">
								<div className="iconDiv">
									<div className="innerIcon">
									<img
    alt="Gemstone Testing"
    src="/manifest/certificate_image.png"
    className="serviceImage"
    data-aos="-in"
    data-aos-delay={200}
/>

									</div>
								</div>
								<div className="stepText" data-aos="-left" data-aos-delay={600}>
									<h4>Online Verification </h4>
									<p>
As the first laboratory in Pakistan, we provide online verification of gemstone certificates for added convenience and security
									</p>
								</div>
							</div>
						</div>
						<div className="stepDiv col-lg-2 col-md-6 col-xs-12 mt-5">
							<div className="innerStepDiv">
								<div className="iconDiv">
									<div className="innerIcon">
										<img
										alt="GemstoneTesting_fr5xpb.webp"
											src={
												"https://res.cloudinary.com/ggi/image/upload/v1637903425/GemstoneTesting_fr5xpb.webp"
											}
											className="serviceImage"
											data-aos="-in"
											data-aos-delay={200}
										/>
									</div>
								</div>
								<div className="stepText" data-aos="-left" data-aos-delay={600}>
									<h4>Diamond grading </h4>
									<p>
									 Our experts utilize the renowned 4Cs (Clarity, Color, Cut, and Carat Weight) to accurately assess the quality of diamonds.

									</p>
								</div>
							</div>
						</div>
						<div className="stepDiv col-lg-2 col-md-6 col-xs-12">
							<div className="innerStepDiv">
								<div className="iconDiv">
									<div className="innerIcon">
										<img
										alt="gem-testing_suqakz.webp"
											src={
												"https://res.cloudinary.com/ggi/image/upload/v1637903426/gem-testing_suqakz.webp"
											}
											className="serviceImage"
											data-aos="-in"
											data-aos-delay={1000}
										/>
									</div>
								</div>
								<div className="stepText" data-aos="-left" data-aos-delay={1400}>
									<h4>Gemstone Testing</h4>
									<p>
									 We employ advanced techniques to identify the type, origin, and any treatments of gemstones.
									</p>
								</div>
							</div>
						</div>
						<div className="stepDiv col-lg-2 col-md-6 col-xs-12 mt-5">
							<div className="innerStepDiv">
								<div className="iconDiv">
									<div className="innerIcon">
										<img
										alt="JewelleryTesting2_rofsml.webp"
											src={
												"https://res.cloudinary.com/ggi/image/upload/v1637903427/JewelleryTesting2_rofsml.webp"
											}
											className="serviceImage"
											data-aos="-in"
											data-aos-delay={1800}
										/>
									</div>
								</div>
								<div className="stepText" data-aos="-left" data-aos-delay={2200}>
									<h4>Jewelry Testing:</h4>
									<p>
									 Our team can determine the authenticity of gold and silver jewelry using various methods, including magnet tests
									</p>
								</div>
							</div>
						</div>
						<div className="stepDiv col-lg-2 col-md-6 col-xs-12">
							<div className="innerStepDiv">
								<div className="iconDiv">
									<div className="innerIcon">
										<img
										alt="AppraisalReports2_cxidmr.webp"
											src={
												"https://res.cloudinary.com/ggi/image/upload/v1637903384/AppraisalReports2_cxidmr.webp"
											}
											className="serviceImage"
											data-aos="-in"
											data-aos-delay={2600}
										/>
									</div>
								</div>
								<div className="stepText" data-aos="-left" data-aos-delay={3000}>
									<h4> Appraisal Services</h4>
									<p>
									We provide comprehensive appraisals for insurance, estate planning, and other purposes.

									</p>
								</div>
							</div>
						</div>
					</div>

					<div className="buttonDiv" data-aos="-in-left">
					<Link to="/laboratory/about-ggi-laboratory">
						<button className="learnMore">
							Check Different Kinds of Lab Reports Available
						</button>
					</Link>
					</div>
				
					<div className="stepText" data-aos="-left" data-aos-delay={3000}>
					<h1 className="title" data-aos="-up" style={{ margin: '30px' }}>
					Why Choose GGILab?
					</h1>

					<div className="centered-container">
    <ul>
     <p>   <strong>Expertise:</strong> Our skilled gemologists have years of experience in the field.<br/>
        <strong>Advanced Technology:</strong> We utilize state-of-the-art equipment for accurate analysis.<br/>
        <strong>Trusted Reputation:</strong> We are committed to providing reliable and unbiased assessments.<br/>
       
	    <strong>Customer Focus:</strong> We prioritize our clients' needs and offer personalized services.<br/>
		</p>
		<p>Trust GGILab to safeguard your valuable gemstones and jewelry</p>
    </ul>
	
</div>


								</div>
				</div>
			</div>
		</div>
		
	);
}
const mapStateToProps = ({ store }) => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Home));
